import { HelpContent } from '../../UI-Lib/Help-Tooltip';

export const TAX_RATE_AREA_HELP: HelpContent[] = [
    {
        helpContentId: 'tax-rate-area.delete-disabled',
        tooltipText: 'Cannot delete as the TRA has Parcels associated.'
    },
    {
        helpContentId: 'tax-rate-area.delete',
        tooltipText: 'Delete'
    }
];
